// src/services/api.js
// Service central pour tous les appels vers l'API Flask

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// ── Helper fetch avec token JWT automatique ──────────────
async function request(endpoint, options = {}) {
  const token = localStorage.getItem('bdk_token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
    ...options,
  };

  const res  = await fetch(`${BASE_URL}${endpoint}`, config);
  const data = await res.json();

  if (!res.ok) {
    // Token expiré ou invalide → on nettoie la session locale
    if (res.status === 401 && token) {
      localStorage.removeItem('bdk_token');
      localStorage.removeItem('bdk_user');
    }
    throw new Error(data.message || `Erreur ${res.status}`);
  }
  return data;
}

// ── AUTH ─────────────────────────────────────────────────
export const authService = {
  login:    (email, password)              => request('/auth/login',    { method: 'POST', body: JSON.stringify({ email, password }) }),
  register: (nom, prenom, email, password) => request('/auth/register', { method: 'POST', body: JSON.stringify({ nom, prenom, email, password }) }),
  me:       ()                             => request('/auth/me'),
  update:   (data)                         => request('/auth/me',       { method: 'PATCH', body: JSON.stringify(data) }),
  delete:   ()                             => request('/auth/me',       { method: 'DELETE' }),
};

// ── PRODUITS ─────────────────────────────────────────────
export const productService = {
  getAll: (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
    ).toString();
    return request(`/products${qs ? '?' + qs : ''}`);
  },
  getById:       (id)  => request(`/products/${id}`),
  getCategories: ()    => request('/products/categories'),
};

// ── PANIER ───────────────────────────────────────────────
export const cartService = {
  get:    ()                         => request('/orders/cart'),
  add:    (product_id, quantite = 1) => request('/orders/cart/add',        { method: 'POST',   body: JSON.stringify({ product_id, quantite }) }),
  update: (item_id, quantite)        => request(`/orders/cart/update/${item_id}`, { method: 'PATCH', body: JSON.stringify({ quantite }) }),
  remove: (item_id)                  => request(`/orders/cart/remove/${item_id}`, { method: 'DELETE' }),
};

// ── PAIEMENT (Stripe) ────────────────────────────────────
export const paymentService = {
  createIntent: () => request('/payments/create-intent', { method: 'POST' }),
  // Parcours sans compte : le panier local est transmis, les prix sont
  // recalculés côté serveur à partir de la base.
  createIntentInvite: (email, items) => request('/payments/create-intent-invite', {
    method: 'POST',
    body: JSON.stringify({ email, items }),
  }),
};

// ── COMMANDES ────────────────────────────────────────────
export const orderService = {
  create:  (data) => request('/orders',    { method: 'POST', body: JSON.stringify(data) }),
  createInvite: (data) => request('/orders/invite', { method: 'POST', body: JSON.stringify(data) }),
  suivre: (reference, email) => request('/orders/suivi', {
    method: 'POST',
    body: JSON.stringify({ reference, email }),
  }),
  myOrders: ()    => request('/orders/me'),
  addReview: (data) => request('/orders/reviews', { method: 'POST', body: JSON.stringify(data) }),
};

// ── ADMIN ────────────────────────────────────────────────
export const adminService = {
  dashboard:     ()          => request('/admin/dashboard'),
  getProducts:   ()          => request('/admin/products'),
  createProduct: (data)      => request('/admin/products',          { method: 'POST',  body: JSON.stringify(data) }),
  updateProduct: (id, data)  => request(`/admin/products/${id}`,    { method: 'PATCH', body: JSON.stringify(data) }),
  deleteProduct: (id)        => request(`/admin/products/${id}`,    { method: 'DELETE' }),
  getOrders:     (params={}) => request(`/admin/orders?${new URLSearchParams(params)}`),
  updateOrder:   (id, data)  => request(`/admin/orders/${id}`,      { method: 'PATCH', body: JSON.stringify(data) }),
  getUsers:      ()          => request('/admin/users'),
  getReviews:    ()          => request('/admin/reviews'),
  approveReview: (id)        => request(`/admin/reviews/${id}/approve`, { method: 'PATCH' }),
  deleteReview:  (id)        => request(`/admin/reviews/${id}`,         { method: 'DELETE' }),
  getMessages:   ()          => request('/admin/messages'),
  readMessage:   (id)        => request(`/admin/messages/${id}/read`,   { method: 'PATCH' }),
};